import { SvgIcon } from '@progress/kendo-react-common';
import { chevronDoubleUpIcon, chevronUpIcon, equalIcon, chevronDownIcon } from '@progress/kendo-svg-icons';

/**
 * Criticality/severity → colored chevron, the shared mapping used across alerts and notifications
 * (Critical ≫, High ∧, Medium =, Low ∨). Case-insensitive, so both 'Critical' and 'critical' work.
 * Returns null for an unknown value so callers can fall back to a default icon.
 */
const CRITICALITY_ICON = {
  critical: { icon: chevronDoubleUpIcon, color: '#780000' },
  high: { icon: chevronUpIcon, color: '#dc0000' },
  medium: { icon: equalIcon, color: '#fd8c00' },
  low: { icon: chevronDownIcon, color: '#fdc500' },
} as const;

export function getCriticalityIcon(criticality: string | null | undefined, size: 'small' | 'medium' | 'large' = 'medium') {
  const entry = CRITICALITY_ICON[(criticality ?? '').toLowerCase() as keyof typeof CRITICALITY_ICON];
  if (!entry) return null;
  return <SvgIcon icon={entry.icon} size={size} color={entry.color} />;
}
